import React, { createContext, useContext, useState, useEffect } from "react";
import apiService from "../services/api";
const AppSettingsContext = createContext();
export const AppSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({ logo: "", siteName: "" });
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await apiService.getApplicationSettings();
        if (response.data.success) {
          setSettings({
            logo: response.data.data["logo"] || "",
            siteName: response.data.data["site-name"] || "",
            footerMenu: response.data.data["footer-menu"] || "",
            pujaPrayersLink:
              response.data.data["puja-prayers-link"] || "puja-request",
            pledgeSupportLink: response.data.data["pledge-support-link"] || "",
            whatsappScanImage: response.data.data["whatsapp-scan-image"] || "",
            joinOurCommunicationTitle:
              response.data.data["join-our-communication-title"] || "",
            whatsappTitle: response.data.data["whatsapp-title"] || "",
            followUsOnFacebookTitle:
              response.data.data["follow-us-on-facebook-title"] || "",
            balviharLink: response.data.data["balvihar-link"] || "",
            deepamLink: response.data.data["deepam-link"] || "",
            templeTimings: response.data.data["temple-timings"] || "",
            copyrightText: response.data.data["copyright-text"] || "",
            bannerImage: response.data.data["banner-image"] || "",
            primaryPhoneNumber:
              response.data.data["primary-phone-number"] || "",
            primaryEmail: response.data.data["primary-email"] || "",
            address: response.data.data["address"] || "",
            facebookUrl: response.data.data["facebook-url"] || "",
            twitterUrl: response.data.data["twitter-url"] || "",
            instagramUrl: response.data.data["instagram-url"] || "",
            PrayerSong: response.data.data["prayer-song"] || "",
            LocationURL: response.data.data["location-url"] || "",
            homeEvents: response.data.data["home-events"] || "",
            homeEventsButton: response.data.data["home-events-button"] || "",
            TempleToursTCTitle:
              response.data.data["temple-tours-tc-title"] || "",
            TempleToursTCDescription:
              response.data.data["temple-tours-tc-description"] || "",
            SocialHallTCTitle: response.data.data["social-hall-tc-title"] || "",
            SocialHallTCDescription:
              response.data.data["social-hall-tc-description"] || "",
            PujaRequestTCTitle:
              response.data.data["puja-request-tc-title"] || "",
            PujaRequestCDescription:
              response.data.data["puja-request-tc-description"] || "",
            changeAndCancelNote:
              response.data.data["change-and-cancel-note"] || "",
          });
        }
      } catch (error) {
        console.error("Error fetching application settings:", error);
      }
    };
    fetchSettings();
  }, []);
  return (
    <AppSettingsContext.Provider value={settings}>
      {children}
    </AppSettingsContext.Provider>
  );
};
export const useAppSettings = () => useContext(AppSettingsContext);
